module.exports = __webpack_public_path__ + "img/program-empty-state.1c29818f.svg";